import {
  isDevelopment,
  isNotProduction,
} from "@/shared/helper/environment.helper";

export const getSecureAttribute = (): string => {
  return isDevelopment ? "" : "; Secure";
};

export const getDomainAttribute = (): string => {
  if (isDevelopment) return "localhost";

  return isNotProduction() ? ".staging.westfalen.com" : ".westfalen.com";
};

export const getEnvValue = () => {
  return isNotProduction() ? "staging" : "production";
};
